import { setClient } from 'features/common/utils/clientParameter'
import { Client } from 'features/common/utils/clientParameter'
import { ReactElement, useEffect } from 'react'
import { Outlet } from 'react-router-dom'

function ClientContext({ client, children }: { client: Client; children?: ReactElement }) {
  setClient(client)

  useEffect(() => {
    return () => {
      setClient(Client.Workspace)
    }
  }, [])
  return children || <Outlet />
}

export default ClientContext
